import React from 'react'

type TopQuestionsHistoricalDataErrorProps = {
  sendFetchRequest: () => void
}

export const TopQuestionsHistoricalDataError: React.FC<TopQuestionsHistoricalDataErrorProps> = () => {


  return <div>
    Failed to fetch historical data
  </div>

}
